import { TableSelectionColumnParams } from '@models/table.model.ts';
import { Tooltip } from '@mui/material';
import RowActions from '@components/row-actions/row-actions.tsx';
import { mediaTypeFilterData } from '@modules/digital-signage/utils/digital-signage.utils.ts';
import { DigitalSignageScreensModel } from '@modules/digital-signage/model/screens.model.ts';
import { formatDate } from '@utils/date-format-utils.ts';
import { getSelectColumn } from '@utils/table-selection.utils.tsx';

export const screensColumns = (
  handleEdit: (row: DigitalSignageScreensModel) => void,
  handleDelete: (row: DigitalSignageScreensModel) => void,
  handlePreview: (row: DigitalSignageScreensModel) => void,
  selection: TableSelectionColumnParams<DigitalSignageScreensModel>
) => [
  getSelectColumn<DigitalSignageScreensModel>(selection),
  {
    id: 'title',
    label: 'column_label_name',
    field: 'title',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value || 'n/a'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'media',
    label: 'column_label_media',
    field: 'media',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'appPath',
    label: 'column_label_app_path',
    field: 'appPath',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: true,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'mediaUrl',
    label: 'column_label_website_url',
    field: 'mediaUrl',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span>{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: false,
    showFilter: false,
    isTranslated: false
  },
  {
    id: 'mediaType',
    label: 'column_label_media_type',
    field: 'mediaType',
    render: (value: any) => (
      <Tooltip title={value} followCursor>
        <span className="capitalize">{value || 'N/A'}</span>
      </Tooltip>
    ),
    showSort: false,
    showSearch: false,
    showFilter: true,
    filterData: mediaTypeFilterData,
    isTranslated: false,
    showSearchInput: false
  },
  {
    id: 'createdAt',
    label: 'column_label_createdAt',
    field: 'createdAt',
    render: (value: any) => (
      <Tooltip title={value ? formatDate(value) : '-'} followCursor>
        <span>{value ? formatDate(value) : '-'}</span>
      </Tooltip>
    ),
    showSort: true,
    showSearch: false,
    showFilter: false
  },
  {
    id: 'Action',
    label: 'column_label_actions',
    field: 'actions',
    render: (value: any, row: DigitalSignageScreensModel) => (
      <RowActions<any>
        row={row}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handlePreview={handlePreview}
      />
    ),
    showSort: false,
    showSearch: false,
    showFilter: false
  }
];
